import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';
import { cn } from 'app/utils/utils';

const Breadcrumb = ({ routeSegments }) => {
  return (
    <div className="flex flex-wrap items-center gap-4 py-2 select-none">
      {/* Current Page Title (Visible on sm+) */}
      {routeSegments && routeSegments.length > 0 && (
        <div className="hidden sm:flex items-center gap-4 border-r pr-4 border-muted-foreground/20">
          <h4 className="text-base font-bold text-foreground capitalize tracking-tight">
            {routeSegments[routeSegments.length - 1].name}
          </h4>
        </div>
      )}

      {/* Breadcrumb Links */}
      <nav className="flex items-center text-sm font-medium">
        <ol className="flex items-center gap-2">
          {/* Home Icon */}
          <li>
            <NavLink 
              to="/" 
              className="p-1.5 rounded-md hover:bg-primary/10 text-primary transition-colors flex items-center justify-center"
            >
              <Home className="w-4 h-4" />
            </NavLink>
          </li>

          {routeSegments && routeSegments.map((route, index) => {
            const isLast = index === routeSegments.length - 1;
            
            return (
              <React.Fragment key={index}>
                <li className="text-muted-foreground/50">
                  <ChevronRight className="w-4 h-4" />
                </li>
                <li>
                  {isLast ? (
                    <span className="text-muted-foreground font-bold capitalize cursor-default">
                      {route.name}
                    </span>
                  ) : (
                    <NavLink
                      to={route.path}
                      className="text-muted-foreground hover:text-primary hover:bg-primary/5 px-2 py-1 rounded-md transition-all capitalize"
                    >
                      {route.name}
                    </NavLink>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
